module.exports = __webpack_public_path__ + "static/media/free-2.a5c33e1a.jpg";